import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../contexts/auth';

export const RedirectAuth: React.FC = () => {
  const { routes } = useContext(AuthContext);
  // Redireciona pra primeira rota que o usuário tem permissão
  return <Redirect to={routes[0].menus[0].url} />;
};
